import { getCache } from '~/cache';

const IMAGE_CACHE_NAME = 'drive-image';
const IMAGE_CACHE_MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000; // 1 month

export const getImageCacheKey = (base64: string) => `${base64.length}_${base64.slice(-20)}`;

export const cacheImage = async (key: string, base64: string) => {
  if (!base64.startsWith('data:')) throw new Error('Invalid base64 data URL');
  const cache = await getCache(IMAGE_CACHE_NAME);
  const cacheKey = new Request(`https://cache/${key}`);
  const response = await fetch(base64);
  const blob = await response.blob();
  const cacheResponse = new Response(blob, {
    headers: { 'x-cached-at': String(Date.now()) },
  });
  await cache.put(cacheKey, cacheResponse);
};

export const getCachedImage = async (key: string) => {
  const cache = await getCache(IMAGE_CACHE_NAME);
  const cacheKey = new Request(`https://cache/${key}`);
  const cached = await cache.match(cacheKey);

  if (!cached) return null;

  const cachedAt = cached.headers.get('x-cached-at');
  if (!cachedAt || Date.now() - Number(cachedAt) >= IMAGE_CACHE_MAX_AGE_MS) {
    void cache.delete(cacheKey);
    return null;
  }

  const blob = await cached.blob();
  return URL.createObjectURL(blob);
};

const cleanupExpiredImages = async () => {
  const cache = await getCache(IMAGE_CACHE_NAME);
  const keys = await cache.keys();
  const now = Date.now();

  // skip cleanup
  if (keys.length < 50) return;

  for (const key of keys) {
    const cached = await cache.match(key);
    if (!cached) continue;
    const cachedAt = cached.headers.get('x-cached-at');
    if (!cachedAt || now - Number(cachedAt) >= IMAGE_CACHE_MAX_AGE_MS) {
      void cache.delete(key);
    }
  }
};

if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', cleanupExpiredImages);
}
